export const FormatCurrencyWithDecimal = (quantity: string | number): string => {
    return `${quantity.toLocaleString("en-US", {style:"currency", currency:"USD"})}`
  };
  